// extracted by mini-css-extract-plugin
export var blue = "_3o-f";
export var brand = "_3o-b";
export var darkGrey = "_3o-e";
export var disabled = "_3o-4";
export var disabledSubtle = "_3o-5";
export var error = "_3o-6";
export var green = "_3o-g";
export var grey = "_3o-d";
export var icon = "_3o-0";
export var inherit = "_3o-a";
export var lightGrey = "_3o-c";
export var orange = "_3o-i";
export var pink = "_3o-k";
export var primary = "_3o-1";
export var purple = "_3o-l";
export var red = "_3o-j";
export var secondary = "_3o-2";
export var success = "_3o-9";
export var tertiary = "_3o-3";
export var warning = "_3o-7";
export var warningSecondary = "_3o-8";
export var white = "_3o-m";
export var yellow = "_3o-h";